import React from "react";
import { useContext, useEffect, useState } from "react";
import { Alert, Button, Table } from "react-bootstrap";
import { DocumentRequestsModel, DocumentsFromLawyerResponse } from "../../../types";
import StateContext from '../../../context/State';
import PortalService from '../../../services/portal.service';
import getIconForFileType from "../../../../../util/getIconForFileType";
import DocumentRequestModal from "./DocumentRequestModal";
import { DefaultDocumentResponse } from "../../../data";


const DocumentsFromClientComponent = () => {

    const { state } = useContext(StateContext)
    const portalService = new PortalService(state);

    const [showModal, setShowModal] = useState<boolean>(false);
    const [documentRequest, setDocumentRequests] = useState<DocumentRequestsModel>([]);
    const [documentsFromClients, setDocumentsFromClients] = useState<DocumentsFromLawyerResponse>(DefaultDocumentResponse);

    // eslint-disable-next-line
    useEffect(() => { getDocumentsFromClient(); getDocumentRequest(); }, []);

    const getDocumentsFromClient = async () => {
        const documentsFromClientResponse: DocumentsFromLawyerResponse = await portalService.getDocumentsFromClient(state.portalId);
        if (documentsFromClientResponse) { setDocumentsFromClients(documentsFromClientResponse) }
    }

    const handleDocumentClicked = async (docName: string) => {
        try {
            await portalService.getClientPortalDocumentFromClient(state.portalId.toString(), docName);
        } catch (e) {
            alert(e);
        }
    }

    const getDocumentRequest = async () => {
        try {
            const documentRequestResponse: DocumentRequestsModel = await portalService.getDocumentRequest(state.portalId)
            if (documentRequestResponse) {
                setDocumentRequests(documentRequestResponse)
            }
        } catch (e) {
            console.log('Unable to get Document Requests: ', e)
        }
    }

    return (
        <>
            <h3>Documents Received From Client</h3>
            {documentsFromClients.Docs.length !== 0 ?
                <Table striped hover>
                    <tbody>
                        {documentsFromClients.Docs.map((doc, index) => {
                            const tempArray = (doc.Name).split("/");
                            const className = getIconForFileType(tempArray.at(-1));
                            return (

                                <tr key={index}>
                                    <td
                                        onClick={() => { handleDocumentClicked(tempArray.at(-1)) }}
                                    >
                                        <i
                                            className={className}
                                            style={{ padding: 5, }}
                                        />
                                        {tempArray.at(-1)}
                                    </td>
                                </tr>

                            )
                        })}
                    </tbody>
                </Table>
                :
                <>
                    <Alert>When your client shares documents to ClientConnect, they will be available here.</Alert>
                </>
            }
            <br />
            {documentRequest.length !== 0 &&
                <Alert>
                    Document Request(s) sent to client:
                    <br />

                    {documentRequest.map((doc, index) => {
                        return (
                            <React.Fragment key={'document-' + index + '-request-fragment'}>
                                - {doc.documentName} <br />
                            </React.Fragment>
                        );
                    })}
                </Alert>
            }
            <br />
            <Button onClick={() => setShowModal(true)}>
                Request Additional Documents
            </Button>
            <DocumentRequestModal
                showModal={showModal}
                onHideModal={() => {
                    getDocumentRequest()
                    // get the most recent document request data to update ui
                    setShowModal(false)
                }}
            />
        </>
    )
}

export default DocumentsFromClientComponent;
